module.exports = __webpack_public_path__ + "img/sld_mfm_inv_914.06257547.svg";